import { IExam } from '../../../types'
import axios from '../../../helpers/axios'

export default {
  async update (context: IExam, payload: { questionParams: {body: string, explanation: string, skill_item_ids: number[], test: boolean, type: string, html_body:string, group: number, answer_items: {name: string, allotment: number, body: string, correct: boolean}[]}[] }): Promise<any> {
    const data = { questionParams: [] };
    payload.questionParams.forEach((questionParam) => {
      const question_param: any = {body: questionParam.body, explanation: questionParam.explanation, field_type: questionParam.type, test: questionParam.test, html_body: questionParam.html_body, group: questionParam.group};
      question_param.skill_item_qs_attributes = questionParam.skill_item_ids.map((skill_item_id) => { return { skill_item_id } });
      question_param.answer_items_attributes = questionParam.answer_items;
      data.questionParams.push(question_param)
    })
    const response = await axios().patch(context.endpoints.update, {exam: data})
    return response.data
  }
}
